import axios from 'axios';
import { message } from 'antd';

const API_BASE = process.env.REACT_APP_API_BASE || '';

const request = axios.create({
  baseURL: `${API_BASE}/api`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

// 请求拦截器 - 附加Token
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('qhy_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.success === false) {
      message.error(res.message || '请求失败');
      return Promise.reject(new Error(res.message));
    }
    return res;
  },
  error => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem('qhy_token');
      localStorage.removeItem('qhy_user');
      window.location.hash = '#/login';
      message.error('登录已过期，请重新登录');
    } else if (status === 501) {
      // 控制通道未接入（后端"诚实化"契约）：提示而非报错
      message.warning(error.response?.data?.message || '该功能尚未接入真实控制通道');
    } else {
      message.error(error.response?.data?.message || error.message || '网络错误');
    }
    return Promise.reject(error);
  }
);

export default request;
